import { Badge } from '@/components/ui/badge';

interface StudentSpecialNeedBadgesProps {
  dyslexic?: boolean | null;
  ell?: boolean | null;
  specialEd?: boolean | null;
}

export function StudentSpecialNeedBadges({
  dyslexic = false,
  ell = false,
  specialEd = false,
}: StudentSpecialNeedBadgesProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {dyslexic && <Badge className="bg-slate-500">Dyslexic</Badge>}
      {ell && <Badge className="bg-blue-500">Emergent bilingual</Badge>}
      {specialEd && <Badge className="bg-orange-500">Special ed</Badge>}
    </div>
  );
}
